// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/baloa-background-login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-login-panel__container {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    gap: var( --grid-gap );
    grid-template-areas: "left left left left right right right right right right right right";
    background-color: var( --white-color );
    height: 150vh;    
}

.signup-login-panel__left-col {
    grid-area: left;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 150vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}

.signup-login-panel__left-col img {
    width: 181px;
    margin-top: 68px;
    margin-left: 48px;
}

.signup-login-panel__right-col {
    grid-column: 7 / 11;
    margin-top: 175px;
    padding: 0 var(--space-and-half);
}

.signup-login-panel__title {
    text-align: center;
}

.signup-login-panel__title.baloa-headline-1 {
    color: var(--primary-very-dark-color);
}

.signup-login-panel__subtitle.baloa-subtitle-2 {
    margin: var(--space-x2) 0;
    color: var(--primary-dark-color);
}

.signup-login-panel__methods__method {
    background: var( --white-color );
    border: 1.2px solid var( --primary-dark-color );
    box-sizing: border-box;
    border-radius: var( --space-half );
    display: flex;
    justify-content: center;
    font-family: var( --secondary-font );
    font-style: normal;
    font-weight: var( --font-medium );
    font-size: calc( var( --space ) + 2px );
    line-height: calc( var( --space ) + var( --space-quarter ) + 1px );
    letter-spacing: 0.04em;
    width: 100%;
    margin-top: var(--space-and-half);
}

.signup-login-panel__methods__method.claim {
    border: 1.5px solid var( --new-gray-background-color );
}

.signup-login-panel__methods__method__label {
    font-family: var( --secondary-font );
    font-style: normal;
    font-weight: var( --font-medium );
    font-size: calc( var( --space ) + 2px );
    line-height: calc( var( --space ) + var( --space-quarter ) + 1px );
    letter-spacing: 0.04em;
}

.signup-login-panel__methods__method .icon-email,
.signup-login-panel__methods__method .hubicon-phone {
    font-size: calc( var( --space ) + var( --space-quarter ));
    margin-right: var( --space-half-quarter );
}

.signup-start-panel__terms-conditions {
    color: var( --new-green-color );
    cursor: pointer;
}

.signup-login-panel__terms-conditions__text {
    margin-top: calc( var( --space-x2 ) + var( --space-half ));
    font-family: var( --secondary-font );
    font-style: normal;
    font-weight: normal;
    font-size: calc( var( --space ) + 3px );
    line-height: calc( var( --space-and-half ) - 2px );
    letter-spacing: 0.0025em;

    color: var( --basic-gray-color );   
}

.signup-start-panel__apple-logo {
 width: calc( var( --space ) + 1px ); 
}

.signup-login-panel__methods__method__apple span {
    color: var( --white-color );
    text-transform: capitalize;
}

.signup-start-panel__apple-logo path {
    fill: var( --white-color );
}

.signup-login-panel__methods__method__apple {
    background-color: var( --black-color );
}

.signup-login-panel__separator__container {
    display: flex;
    justify-content: space-between;
    align-items: center;   
    margin: var( --space-x2 ) 0;
}

.signup-login-panel__separator {
    width: 50%;
    border-bottom: 1px solid var( --black-color );
    height: 0;
}

.signup-login-panel__separator:first-of-type {
    margin-right: var( --space-half-quarter );
}

.signup-login-panel__separator:last-of-type {
    margin-left: var( --space-half-quarter );
}

.signup-login-panel__methods__method.phone {
    margin-top: 0;
}

.signup-login-panel__right-col .new-account__methods {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.new-account__methods .secondary-button {
    color: var(--new-text-link-color);
}

.new-account__methods .secondary-button:hover {
    color: var(--white-color);
}

.signup-login-panel__guest-mode {
    margin: 32px 0 72px 0;
}

.signup-login-panel__guest-mode .baloa-normal-medium {
    color: var(--primary-very-dark-color);
}

.signup-login-panel__terms-conditions.baloa-normal {
    color: var(--basic-gray-color);
}

.signup-login-panel__terms-conditions.baloa-normal span {
    color: var(--new-green-color);
    cursor: pointer;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .signup-login-panel__container {
      display: block;
      position: relative;
      height: 100vh;
    }
    .signup-login-panel__left-col {
        position: absolute;
        width: 100%;
        z-index: 1;
        height: 100vh;
    }
    .signup-login-panel__left-col a {
        display: flex;
        justify-content: center;
    }
    .signup-login-panel__left-col img {
        width: 214px;
        margin-top: calc( var(--space-x3) - var(--space-half) );
        margin-left: 0;
    }
    .signup-login-panel__right-col {
        margin-top: 0;
        z-index: 2;
        position: absolute;
        bottom: var(--space);
        padding: 0;
        height: 100vh;
    }
    .signup-login-panel__title.baloa-headline-1 {
        display: none;
    }
    .signup-login-panel__subtitle.baloa-subtitle-2 {
        margin: 50% var(--space-x3) 0 var(--space);
        font-size: calc( var(--space-x2) + var(--space-half) );
        color: var(--white-color);
        line-height: calc( var(--space-x2) + var(--space-half) + var(--space-quarter) );
    }
    .signup-login-panel__terms-conditions.baloa-normal {
        color: rgba(255, 255, 255, 0.7);
    }
    .signup-login-panel__terms-conditions.baloa-normal span {
        color: var(--white-color);
    }
    .signup-login-panel__guest-mode .baloa-normal-medium {
        color: var(--white-color);  
    }
    .signup-login-panel__guest-mode {
        margin: var(--space-x2);
    }
    .signup-login-panel__methods__method .button,
    .new-account__methods .secondary-button {
        padding: calc( var(--space-half-quarter) + var(--space-eighth) );
    }
    .signup-login-panel__right-col .new-account__methods {
        position: absolute;
        bottom: var(--space);
        width: 100%;
        padding: 0 var(--space);
    }
    .signup-login-panel__methods__method__label { 
        white-space: nowrap; 
    }
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/components/signup-login-panel/SignUpLoginPanelComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;IACtC,wBAAwB;IACxB,sBAAsB;IACtB,0FAA0F;IAC1F,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,yDAA6E;IAC7E,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,+CAA+C;IAC/C,sBAAsB;IACtB,kCAAkC;IAClC,aAAa;IACb,uBAAuB;IACvB,oCAAoC;IACpC,kBAAkB;IAClB,iCAAiC;IACjC,uCAAuC;IACvC,kEAAkE;IAClE,sBAAsB;IACtB,WAAW;IACX,iCAAiC;AACrC;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,iCAAiC;IACjC,uCAAuC;IACvC,kEAAkE;IAClE,sBAAsB;AAC1B;;AAEA;;IAEI,yDAAyD;IACzD,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,0DAA0D;IAC1D,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,kDAAkD;IAClD,wBAAwB;;IAExB,gCAAgC;AACpC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,6CAA6C;IAC7C,SAAS;AACb;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA,yCAAyC,4BAA4B;IACjE;MACE,cAAc;MACd,kBAAkB;MAClB,aAAa;IACf;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,aAAa;IACjB;IACA;QACI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,YAAY;QACZ,uDAAuD;QACvD,cAAc;IAClB;IACA;QACI,aAAa;QACb,UAAU;QACV,kBAAkB;QAClB,oBAAoB;QACpB,UAAU;QACV,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,0CAA0C;QAC1C,sDAAsD;QACtD,yBAAyB;QACzB,+EAA+E;IACnF;IACA;QACI,+BAA+B;IACnC;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,uBAAuB;IAC3B;IACA;;QAEI,gEAAgE;IACpE;IACA;QACI,kBAAkB;QAClB,oBAAoB;QACpB,WAAW;QACX,uBAAuB;IAC3B;IACA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".signup-login-panel__container {\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    grid-template-rows: auto;\n    gap: var( --grid-gap );\n    grid-template-areas: \"left left left left right right right right right right right right\";\n    background-color: var( --white-color );\n    height: 150vh;    \n}\n\n.signup-login-panel__left-col {\n    grid-area: left;\n    background-image: url(\"../../../../assets/images/baloa-background-login.png\");\n    height: 150vh;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.signup-login-panel__left-col img {\n    width: 181px;\n    margin-top: 68px;\n    margin-left: 48px;\n}\n\n.signup-login-panel__right-col {\n    grid-column: 7 / 11;\n    margin-top: 175px;\n    padding: 0 var(--space-and-half);\n}\n\n.signup-login-panel__title {\n    text-align: center;\n}\n\n.signup-login-panel__title.baloa-headline-1 {\n    color: var(--primary-very-dark-color);\n}\n\n.signup-login-panel__subtitle.baloa-subtitle-2 {\n    margin: var(--space-x2) 0;\n    color: var(--primary-dark-color);\n}\n\n.signup-login-panel__methods__method {\n    background: var( --white-color );\n    border: 1.2px solid var( --primary-dark-color );\n    box-sizing: border-box;\n    border-radius: var( --space-half );\n    display: flex;\n    justify-content: center;\n    font-family: var( --secondary-font );\n    font-style: normal;\n    font-weight: var( --font-medium );\n    font-size: calc( var( --space ) + 2px );\n    line-height: calc( var( --space ) + var( --space-quarter ) + 1px );\n    letter-spacing: 0.04em;\n    width: 100%;\n    margin-top: var(--space-and-half);\n}\n\n.signup-login-panel__methods__method.claim {\n    border: 1.5px solid var( --new-gray-background-color );\n}\n\n.signup-login-panel__methods__method__label {\n    font-family: var( --secondary-font );\n    font-style: normal;\n    font-weight: var( --font-medium );\n    font-size: calc( var( --space ) + 2px );\n    line-height: calc( var( --space ) + var( --space-quarter ) + 1px );\n    letter-spacing: 0.04em;\n}\n\n.signup-login-panel__methods__method .icon-email,\n.signup-login-panel__methods__method .hubicon-phone {\n    font-size: calc( var( --space ) + var( --space-quarter ));\n    margin-right: var( --space-half-quarter );\n}\n\n.signup-start-panel__terms-conditions {\n    color: var( --new-green-color );\n    cursor: pointer;\n}\n\n.signup-login-panel__terms-conditions__text {\n    margin-top: calc( var( --space-x2 ) + var( --space-half ));\n    font-family: var( --secondary-font );\n    font-style: normal;\n    font-weight: normal;\n    font-size: calc( var( --space ) + 3px );\n    line-height: calc( var( --space-and-half ) - 2px );\n    letter-spacing: 0.0025em;\n\n    color: var( --basic-gray-color );   \n}\n\n.signup-start-panel__apple-logo {\n width: calc( var( --space ) + 1px ); \n}\n\n.signup-login-panel__methods__method__apple span {\n    color: var( --white-color );\n    text-transform: capitalize;\n}\n\n.signup-start-panel__apple-logo path {\n    fill: var( --white-color );\n}\n\n.signup-login-panel__methods__method__apple {\n    background-color: var( --black-color );\n}\n\n.signup-login-panel__separator__container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;   \n    margin: var( --space-x2 ) 0;\n}\n\n.signup-login-panel__separator {\n    width: 50%;\n    border-bottom: 1px solid var( --black-color );\n    height: 0;\n}\n\n.signup-login-panel__separator:first-of-type {\n    margin-right: var( --space-half-quarter );\n}\n\n.signup-login-panel__separator:last-of-type {\n    margin-left: var( --space-half-quarter );\n}\n\n.signup-login-panel__methods__method.phone {\n    margin-top: 0;\n}\n\n.signup-login-panel__right-col .new-account__methods {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.new-account__methods .secondary-button {\n    color: var(--new-text-link-color);\n}\n\n.new-account__methods .secondary-button:hover {\n    color: var(--white-color);\n}\n\n.signup-login-panel__guest-mode {\n    margin: 32px 0 72px 0;\n}\n\n.signup-login-panel__guest-mode .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n}\n\n.signup-login-panel__terms-conditions.baloa-normal {\n    color: var(--basic-gray-color);\n}\n\n.signup-login-panel__terms-conditions.baloa-normal span {\n    color: var(--new-green-color);\n    cursor: pointer;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .signup-login-panel__container {\n      display: block;\n      position: relative;\n      height: 100vh;\n    }\n    .signup-login-panel__left-col {\n        position: absolute;\n        width: 100%;\n        z-index: 1;\n        height: 100vh;\n    }\n    .signup-login-panel__left-col a {\n        display: flex;\n        justify-content: center;\n    }\n    .signup-login-panel__left-col img {\n        width: 214px;\n        margin-top: calc( var(--space-x3) - var(--space-half) );\n        margin-left: 0;\n    }\n    .signup-login-panel__right-col {\n        margin-top: 0;\n        z-index: 2;\n        position: absolute;\n        bottom: var(--space);\n        padding: 0;\n        height: 100vh;\n    }\n    .signup-login-panel__title.baloa-headline-1 {\n        display: none;\n    }\n    .signup-login-panel__subtitle.baloa-subtitle-2 {\n        margin: 50% var(--space-x3) 0 var(--space);\n        font-size: calc( var(--space-x2) + var(--space-half) );\n        color: var(--white-color);\n        line-height: calc( var(--space-x2) + var(--space-half) + var(--space-quarter) );\n    }\n    .signup-login-panel__terms-conditions.baloa-normal {\n        color: rgba(255, 255, 255, 0.7);\n    }\n    .signup-login-panel__terms-conditions.baloa-normal span {\n        color: var(--white-color);\n    }\n    .signup-login-panel__guest-mode .baloa-normal-medium {\n        color: var(--white-color);  \n    }\n    .signup-login-panel__guest-mode {\n        margin: var(--space-x2);\n    }\n    .signup-login-panel__methods__method .button,\n    .new-account__methods .secondary-button {\n        padding: calc( var(--space-half-quarter) + var(--space-eighth) );\n    }\n    .signup-login-panel__right-col .new-account__methods {\n        position: absolute;\n        bottom: var(--space);\n        width: 100%;\n        padding: 0 var(--space);\n    }\n    .signup-login-panel__methods__method__label { \n        white-space: nowrap; \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
